import { useMutation } from '@apollo/client';
import { Table, notification } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setGroupData } from '@src/middleware/redux/reducers/group.reducer';
import { DeleteConfirmationModal } from '@src/pages/setting/dataFields/modal/deleteConfirmation.modal';
import { setPropertyFilterByGroup } from '@src/middleware/redux/reducers/properties.reducer';
import { Spinner } from '@react-pdf-viewer/core';
import { deleteTaskGroupMutation } from '../../util/mutation/taskgroup.mutation';
import dayjs from 'dayjs';

export const TaskGroupGrid = ({groupList, groupLoading, groupRefetch, editGroup, setActiveTab}) => {

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [hoveredRow, setHoveredRow] = useState(null);
  const [deleteGroupConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [groupToBeDelete, setGroupToBeDelete] = useState({});
  const [groupIdToMoveIn, setGroupIdToMoveIn] = useState();

  const dispatch = useDispatch();

  useEffect(()=>{
    if(groupRefetch){
        groupRefetch();
    }
  },[groupRefetch])
  
  // console.log(data, "dataaa");

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


    

  const [deleteTaskGroup, {loading: deleteTaskGroupLoading}] = useMutation(deleteTaskGroupMutation)

  const handleDelete = async (record) => {

    if(record?.taskCount){
      
      alert("Sorry! this group is already associated with tasks. You can't delete this group.");

    }else{
      // handle delete action for the selected record
     
      setGroupToBeDelete(record);
      setDeleteConfirmationModal(true);
    }

  };

  const rowClassName = (record) => {
    return record.key === hoveredRow ? 'hovered-row' : '';
  };
  const handleRowMouseEnter = (record) => {
    setHoveredRow(record.key);
  };

  const handleRowMouseLeave = () => {
    setHoveredRow(null);
  };

  const handleViewProperty = (record) => {
    dispatch(setPropertyFilterByGroup(record));
    setActiveTab('1');
  };  

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === 'name' ? sortedInfo.order : null,
      // width:300,
      render: (_, record) => {
        const showActions = hoveredRow === record.key;
        return (
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
              <div style={{lineHeight:'35px'}} className='truncated-text'>
                {record.name}
              </div>

              {showActions && 
              <div style={{width:'100%', display:'flex', justifyContent:'flex-end' ,alignItems:'center', columnGap:'5px'}}>
                <button  className="sm-btn" type="link" onClick={() => editGroup(record)}>
                  Edit
                </button>
                <button  className="sm-btn" style={{width:'max-content'}} type="link" onClick={() => handleViewProperty(record)}>
                  View fields
                </button>

                <button  className="sm-btn" type="link" onClick={() => handleDelete(record)}>
                  Delete
                </button>
              </div>
              }
            </div>
        );
      },

    },
    {
      title: 'Number of Task',
      dataIndex: 'taskCount',
      key: 'taskCount',
      sorter: (a, b) => a.properties - b.properties,
      sortOrder: sortedInfo.columnKey === 'taskCount' ? sortedInfo.order : null,
      ellipsis: true,
      width:'fit-content'
    },
    {
      title: 'Created By',
      dataIndex: 'createdBy',
      key: 'createdBy',
      sorter: (a, b) => a.createdBy - b.createdBy,
      sortOrder: sortedInfo.columnKey === 'task' ? sortedInfo.order : null,
      ellipsis: true,
      width:'fit-content'
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => a.createdAt - b.createdAt,
      sortOrder: sortedInfo.columnKey === 'task' ? sortedInfo.order : null,
      ellipsis: true,
      width:'fit-content'
    },
  ];
  
  const [selectedRowKeys, setSelectedRowKeys]=useState([])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  const [api, contextHolder] = notification.useNotification();
  const deleteRecord = async ()=>{
    
      await deleteTaskGroup({
        variables:{
          id: record?.key
        }
      });
      setDeleteConfirmationModal(false);
      await groupRefetch();
      setGroupToBeDelete(null);
      api.success({
        message: "Group was deleted",
        placement:"top",
        className: 'notification-without-close',
      });
    
  }

  
  return (
    <div 
    className='setting-grid'>
      {contextHolder}
      {!groupLoading? 
      <>
      <Table 
        columns={columns} 
        dataSource={groupList?.length>0?[...groupList?.map((grp)=>({key: grp?._id, task: grp?.task || "--", name: grp?.name, createdBy: grp?.createdBy?.firstname + " "+grp?.createdBy?.lastname, taskCount: grp?.taskCount, createdAt: dayjs(grp?.createdAt).format("DD/MM/YYYY HH:mm")}))]:null} 
        // rowSelection={rowSelection}
        onChange={handleChange}
        className='curvedTable'
        loading={deleteTaskGroupLoading}
        onRow={(record) => ({
          onMouseEnter: () => handleRowMouseEnter(record),
          onMouseLeave: () => handleRowMouseLeave(),
        })}
        rowClassName={rowClassName}

      />
      {deleteGroupConfirmationModal && 
      <DeleteConfirmationModal
        visible={deleteGroupConfirmationModal}
        onClose={()=>setDeleteConfirmationModal(false)}
        label={groupToBeDelete?.name}
        properties={groupToBeDelete?.properties}
        loading={deleteLoading}
        deleteRecord={deleteRecord}
        groupList={[...groupList.filter((group)=>group.name!==groupToBeDelete?.name)]}
        title={"group"}
        additionalText={true}
        setGroupIdToMoveIn={setGroupIdToMoveIn}
      /> }
      </>
      : 
      <div style={{marginTop:'10%'}} >
        <Spinner/>
      </div>
      }
    </div>
  );
};
